import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import membershipApi from '../../../services/membershipApi';
import { getSlimLogoPath } from '../../../utils/slimLogo';

const MemberLogin = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      const response = await membershipApi.auth.login(formData);
      
      if (response.data.success) {
        // Save token & user info (separate from staff login storage if needed)
        sessionStorage.setItem('accessToken', response.data.token);
        localStorage.setItem('memberInfo', JSON.stringify(response.data.data.member));
        
        toast.success(`Welcome back, ${response.data.data.member.name}!`);
        navigate('/membership/dashboard');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Login failed. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 bg-opacity-90 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-2xl border border-blue-100">
        <div>
          <img className="mx-auto h-16 w-auto" src={getSlimLogoPath()} alt="SLIM ERP Logo" />
          <h2 className="mt-6 text-center text-3xl font-medium text-gray-900">
            Club Member Portal
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Access your points, tiers, and member benefits
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">Email address</label>
              <input
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Email address"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="password" name="password" className="sr-only">Password</label>
              <input
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={isLoading}
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300"
            >
              {isLoading ? 'Signing in' : 'Sign in to Member Portal'}
            </button>
          </div>
          
          <div className="text-center text-sm text-gray-500">
            <Link to="/membership/register" className="font-medium text-blue-600 hover:text-blue-500">
              Not a member yet? Join the club today
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MemberLogin;
